var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-status-18x18",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.40900974,3.80545635 L4.05545635,4.15900974 L5.64644661,5.75 L4.05545635,7.34099026 L4.40900974,7.69454365 L6,6.10355339 L7.59099026,7.69454365 L7.94454365,7.34099026 L6.35355339,5.75 L7.94454365,4.15900974 L7.59099026,3.80545635 L6,5.39644661 L4.40900974,3.80545635 Z M4.35007134,12.4948919 L3.99651795,12.8484453 L5.07196178,13.9238892 L5.06941147,13.9264395 L5.42296486,14.2799929 L8.25139198,11.4515657 L7.89783859,11.0980124 L5.42551518,13.5703358 L4.35007134,12.4948919 Z M10.75,5.5 C10.6119288,5.5 10.5,5.61192881 10.5,5.75 C10.5,5.88807119 10.6119288,6 10.75,6 L13.25,6 C13.3880712,6 13.5,5.88807119 13.5,5.75 C13.5,5.61192881 13.3880712,5.5 13.25,5.5 L10.75,5.5 Z M10.75,12.5 C10.6119288,12.5 10.5,12.6119288 10.5,12.75 C10.5,12.8880712 10.6119288,13 10.75,13 L13.25,13 C13.3880712,13 13.5,12.8880712 13.5,12.75 C13.5,12.6119288 13.3880712,12.5 13.25,12.5 L10.75,12.5 Z M3,0.5 C1.61928813,0.5 0.5,1.61928813 0.5,3 L0.5,15 C0.5,16.3807119 1.61928813,17.5 3,17.5 L15,17.5 C16.3807119,17.5 17.5,16.3807119 17.5,15 L17.5,3 C17.5,1.61928813 16.3807119,0.5 15,0.5 L3,0.5 Z M3,1 L15,1 C16.1045695,1 17,1.8954305 17,3 L17,15 C17,16.1045695 16.1045695,17 15,17 L3,17 C1.8954305,17 1,16.1045695 1,15 L1,3 C1,1.8954305 1.8954305,1 3,1 Z",
    id: "Combined-Shape",
    stroke: "#9CAAB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.45c0aa14ffd7e1ea0986cd753b3dc7e7.svg";
export { ForwardRef as ReactComponent };